var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterXFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1761 4.5H19.9362L13.9061 11.3912L21 20.7686H15.4456L11.0951 15.0812L6.11723 20.7686H3.35544L9.80517 13.3976L3 4.5H8.69545L12.6279 9.69843L17.1761 4.5ZM16.2073 19.1167H17.7368L7.86441 6.06512H6.2232L16.2073 19.1167Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterXFill);
export default __webpack_public_path__ + "static/media/twitter-x-fill.a57d795fd740419a6ec110f73af21438.svg";
export { ForwardRef as ReactComponent };